/**
 * CRUD admin — material SIMCE (Django simce app).
 */
import axios from 'axios';
import { getDjangoAdminToken } from '@/services/djangoAdminAuth';

const BACK = (process.env.VUE_APP_BACK_URL || '').replace(/\/$/, '');
const SIM = `${BACK}/simce`;

function headers(json = true) {
  const h = { Accept: 'application/json' };
  const t = getDjangoAdminToken();
  if (t) h.Authorization = `Bearer ${t}`;
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

function list(url, params) {
  return axios.get(url, { headers: headers(), params }).then((r) => r.data);
}

function create(url, payload) {
  return axios.post(url, payload, { headers: headers() }).then((r) => r.data);
}

export const SimceApi = {
  listAsignaturas: (p) => list(`${SIM}/asignaturas-simce/`, p),
  listEjes: (p) => list(`${SIM}/ejes-tematicos/`, p),
  listEstandares: (p) => list(`${SIM}/estandares-aprendizaje/`, p),
  listTiposActividad: (p) => list(`${SIM}/tipos-actividad-simce/`, p),
  listItems: (p) => list(`${SIM}/items-simce/`, p),
  listOpciones: (p) => list(`${SIM}/opciones-item-simce/`, p),
  listPlantillas: (p) => list(`${SIM}/plantillas-ensayo/`, { lite: '1', ...p }),
  listPlantillaItems: (p) => list(`${SIM}/plantillas-ensayo-items/`, p),
  catalogoEstructura: (p) => list(`${SIM}/reportes/catalogo-estructura/`, p),
  createItem: (payload) => create(`${SIM}/items-simce/`, payload),
  importarItemsXlsx(archivo, opts = {}) {
    const fd = new FormData();
    fd.append('archivo', archivo);
    if (opts.grupo) fd.append('grupo', opts.grupo);
    if (opts.plantilla) fd.append('plantilla', '1');
    if (opts.replace) fd.append('replace', '1');
    if (opts.dryRun) fd.append('dry_run', '1');
    return axios.post(`${SIM}/items-simce/importar-xlsx/`, fd, {
      headers: { ...headers(false), 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
};

export { descargarBlob } from '@/services/EstudyooAdminApi';
